import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  tone?: "yellow" | "purple" | "blue" | "green" | "red" | "ink";
  icon?: ReactNode;
};

const tones: Record<NonNullable<Props["tone"]>, string> = {
  yellow: "bg-brand-yellow-soft text-brand-yellow",
  purple: "bg-brand-purple-soft text-brand-purple",
  blue: "bg-brand-blue-soft text-brand-blue",
  green: "bg-brand-green-soft text-brand-green",
  red: "bg-brand-red-soft text-brand-red",
  ink: "bg-ink-100 text-ink-700",
};

export function Badge({ children, tone = "ink", icon }: Props) {
  return (
    <span
      className={`
        inline-flex items-center gap-1 px-2.5 py-1
        rounded-full text-[12px] font-bold uppercase tracking-wider
        ${tones[tone]}
      `}
    >
      {icon && <span className="text-[14px]">{icon}</span>}
      {children}
    </span>
  );
}
